import { type LazyQueryExecFunction, useLazyQuery } from "@apollo/client";

import { type GetLensStatusQuery, type GetLensStatusQueryVariables, getLensStatus } from "../../lens/api/queries";
import { type ApolloResult } from "../../shared/models";

export const useLensStatus = (
    lensId: string,
): ApolloResult<{
    getUpdatingLensStatus: LazyQueryExecFunction<GetLensStatusQuery, GetLensStatusQueryVariables>;
}> => {
    const [getUpdatingLensStatus, { loading, error }] = useLazyQuery<GetLensStatusQuery, GetLensStatusQueryVariables>(
        getLensStatus,
        {
            fetchPolicy: "network-only",
            variables: {
                lensId,
            },
        },
    );

    return { getUpdatingLensStatus, loading, error };
};
